import styled from "styled-components";
import { Select } from "antd";

export const Container = styled.div`
  .bulk-reindex {
    margin: 54px;

    h1 {
      margin-bottom: 22px;
    }

    p {
      margin-bottom: 12px;
      font-family: ${props => props.theme.p3m.ff};
      font-size: ${props => props.theme.p3m.fs};
      letter-spacing: 1px;
      color: ${props => props.theme.textLight};
    }

    form {
      width: 40%;
      margin: 20px 20px;

      .form-row {
        display: flex;
        align-items: center;
        margin: 20px 0;

        .form-row-label {
          width: 69px;
          color: ${props => props.theme.textLight};
        }

        .form-row-input {
          width: 100%;
        }
      }
    }

    div.ant-alert {
      width: 60%;
      margin-top: 20px;
    }

    .reindex-btn {
      margin-left: -12px;
    }
  }
`;

export const IndexSelect = styled(Select)`
  background-color: ${({ theme }) => theme.editor.backgroundLight};
  color: ${({ theme }) => theme.editor.textLight};
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontMedium};

  .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-radius: 3px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  .ant-select-selection__rendered {
    padding-right: 15px;
    line-height: 20px;
  }

  .ant-select-selection.ant-select-selection--multiple {
    display: block;
    background-color: ${({ theme }) => theme.editor.backgroundLight};
    color: ${({ theme }) => theme.editor.textLight};
  }

  .ant-select-selection__placeholder {
    margin-top: -4px;
  }

  .ant-select-selection__choice {
    border-radius: 12px;
    color: ${({ theme }) => theme.editor.textLight};
    border: 1px solid ${({ theme }) => theme.editor.highlightDark} !important;
    background-color: ${({ theme }) => theme.editor.highlightDark} !important;
  }

  .ant-select-selection__choice__remove {
    color: ${({ theme }) => theme.editor.textLight} !important;
  }

  .ant-select-dropdown {
    background-color: transparent;
  }

  .ant-select-dropdown > div {
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
  }

  .ant-select-dropdown-menu-item {
    background-color: ${({ theme }) => theme.editor.backgroundDark} !important;
    color: ${({ theme }) => theme.editor.textLight} !important;
  }

  .ant-select-dropdown-menu-item-selected {
    background-color: ${({ theme }) => theme.editor.highlightDark} !important;
  }

  .ant-select-dropdown-menu-item-active {
    background-color: ${({ theme }) =>
      theme.editor.backgroundHighlight} !important;
  }
`;
